<div>
  <h2 mat-dialog-title>Edit {{ this.data.campusToEdit.name }}</h2>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <mat-dialog-content>
    <form [formGroup]="editCampusForm" class="flex flex-col">
      <mat-form-field>
        <mat-label> Name </mat-label>
        <input
          matInput
          type="text"
          formControlName="name"
          placeholder="Name"
          maxlength=""
        />
        <mat-error *ngIf="this.editCampusForm.controls.name.invalid">
          Name is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label> Email Domain </mat-label>
        <input
          matInput
          type="text"
          formControlName="emailDomain"
          placeholder="abu.edu"
          maxlength=""
        />
        <mat-error *ngIf="this.editCampusForm.controls.emailDomain.invalid">
          Email domain is required.
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label> Street </mat-label>
        <input matInput type="text" formControlName="street" maxlength="" />
        <mat-error *ngIf="this.editCampusForm.controls.street.invalid">
          Street is required.
        </mat-error>
      </mat-form-field>

      <div class="flex flex-col md:flex-row gap-2 w-full">
        <mat-form-field>
          <mat-label> City </mat-label>
          <input matInput type="text" formControlName="city" maxlength="" />
          <mat-error *ngIf="this.editCampusForm.controls.city.invalid">
            City is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label> State </mat-label>
          <mat-select formControlName="state">
            @for (state of states; track state) {
            <mat-option [value]="state">{{ state }}</mat-option>
            }
          </mat-select>
          <mat-error *ngIf="this.editCampusForm.controls.state.invalid">
            State is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label> Zipcode </mat-label>
          <input matInput type="text" formControlName="zipcode" maxlength="5" />
          <mat-error *ngIf="this.editCampusForm.controls.zipcode.invalid">
            Zipcode is required.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-row">
        <div class="w-1/2">
          <mat-label> Status</mat-label>
          <p>
            <mat-slide-toggle
              [checked]="this.statusChecked"
              (click)="statusChecked = !statusChecked"
            >
              {{ this.statusChecked ? "ACTIVE" : "INACTIVE" }}
            </mat-slide-toggle>
          </p>
        </div>
        <div>
          <mat-label> Main Campus</mat-label>
          <p>
            <mat-slide-toggle
              [checked]="this.mainCampusChecked"
              (click)="mainCampusChecked = !mainCampusChecked"
            >
              {{ this.mainCampusChecked ? "Yes" : "No" }}
            </mat-slide-toggle>
          </p>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-raised-button (click)="onCancel()">Cancel</button>
    <button
      mat-raised-button
      color="accent"
      [disabled]="this.editCampusForm.invalid"
      (click)="onSubmit()"
    >
      Submit
    </button>
  </mat-dialog-actions>
</div>
